<div class="col-12 px-0">
  <p class="page-header">List of ultimate remitters</p>
</div>

<ng-container *ngIf="registrationService.userRole !== userRoleEnum.ReadOnly">
  <div class="px-0 ml-auto col-3 form-group">
    <button type="button" class="btn btn-lg btn-block btn-greengo" (click)="add()">Add new ultimate remitter</button>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading">
  <ng-table-pagination
    [rows]="rows"
    [columns]="columns"
    [totalItems]="totalCount"
    [filterByApi]="true"
    [pageSize]="pageSize"
    [showCheckbox]="false"
    (tableChanged)="tableChanged($event)"
    (cellDblClicked)="ultimateRemitterDblClicked($event)">
  </ng-table-pagination>
</ng-container>
